import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { RecoilRoot } from 'recoil';
import { Fallback } from 'pages/fallback/fallback';
import { SavedProjectConfigurationPage } from 'pages/saved-project-configuration';
import { ErrorBoundary } from '../../error-boundary';
import { TData } from './context';

export type SavedProjectConfigurationProps = TData;
export type SavedProjectConfigurationState = TData;

export const SavedProjectConfiguration: React.FC<TData> = data => {
  if (!data.id) {
    return null;
  }

  return (
    <ThemeProvider>
      <ErrorBoundary
        fallback={
          <Fallback
            title="Ой, что-то пошло не так..."
            description="Попробуйте обновить страницу"
            buttonText="Обновить страницу"
          />
        }>
        <RecoilRoot>
          <SavedProjectConfigurationPage data={data} />
        </RecoilRoot>
      </ErrorBoundary>
    </ThemeProvider>
  );
};
